import React, { useState, useEffect, useRef } from 'react';
import { streamChatService } from '../services/streamChatService';
import { supabase } from '../services/supabase';
import '../styles/ChatWidget.css';

const ChatWidget = ({ streamId }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (!streamId) return;

    const loadMessages = async () => {
      try {
        setLoading(false);
        const data = await streamChatService.getMessages(streamId);
        setMessages(data);
      } catch (err) {
        console.error('Error loading messages:', err);
        setLoading(false);
      }
    };

    loadMessages();
  }, [streamId]);

  useEffect(() => {
    if (!streamId) return;

    let subscription;

    try {
      subscription = supabase
        .from('live_chat')
        .on('INSERT', (payload) => {
          if (payload.new.stream_id === streamId) {
            setMessages((prev) => [...prev, payload.new]);
          }
        })
        .on('DELETE', (payload) => {
          if (payload.old.stream_id === streamId) {
            setMessages((prev) => prev.filter((m) => m.id !== payload.old.id));
          }
        })
        .subscribe();
    } catch (err) {
      console.error('Error subscribing to chat:', err);
    }

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [streamId]);

  return (
    <div className="chat-widget">
      <div className="widget-messages">
        {loading ? (
          <p className="widget-loading">Loading chat...</p>
        ) : messages.length === 0 ? (
          <p className="widget-empty">Waiting for messages...</p>
        ) : (
          <>
            {messages.map((msg) => (
              <div key={msg.id} className={`widget-message ${msg.is_admin ? 'admin' : ''}`}>
                <span className="widget-username">
                  {msg.username}
                  {msg.is_admin && <span className="widget-admin-badge">●</span>}
                </span>
                <span className="widget-text">{msg.message}</span>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </>
        )}
      </div>
    </div>
  );
};

export default ChatWidget;
